import { configureStore } from '@reduxjs/toolkit';

import { useSelector } from 'react-redux';

import UserSlice from './Slicers/UserSlice';

const GlobalStore = configureStore({
    reducer: {
        user: UserSlice,
    },
});
export default GlobalStore;

export type GlobalStoreState = ReturnType<typeof GlobalStore.getState>;

export const useGlobalStoreSelector = <TSelected>(
    selector: (state: GlobalStoreState) => TSelected,
    equalityFn?: (left: TSelected, right: TSelected) => boolean
) => useSelector(selector, equalityFn);
